import { render, staticRenderFns } from "./TwitterPost.vue?vue&type=template&id=00b8859d&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8859d",
  null
  
)

export default component.exports